import _ from "lodash";

const keyFn = (idField, item, idx) => {
  const keyFn = (item, idx) => item[idField];
  return _.isString(idField) ? keyFn(item, idx) : idField(item, idx);
};

export const reduceList = (list, idField, hidden) => {
  return {
    type: "list",
    hidden: hidden,
    value: list.reduce((acc, c, idx) => ({ ...acc, [keyFn(idField, c, idx)]: idx }), {})
  };
};

export const reduceListExtra = (list, idField, process, group) => {
  return list.reduce(
    (acc, c, idx) => ({
      ...acc,
      [keyFn(idField, c, idx)]: { hidden: true, props: process(c, idx), group: group }
    }),
    {}
  );
};



// WEBPACK FOOTER //
// ./src/spreadsheet/providers/utils.js